export default __webpack_public_path__ + "static/tidb-banner-b07d1bc63926bef463985da1a3e25957.svg";